<template>
  <div>
    <b-col :class="$style.navOptionsWrapper">
      <b-row>
        <!-- Sign up button -->
        <div
          v-if="!loggedIn"
          :class="$style.signUpBtn"
        >
          <BaseLink
            key="signup"
            name="signup"
            exact-active-class="{$style.active}"
            :class="$style.link"
          >
            <b-button
              squared
              size="sm"
              :class="$style.customButton"
              type="submit"
            >
              <b-icon icon="person"></b-icon>
              Sign Up
            </b-button>
          </BaseLink>
        </div>
        <!-- Log out button -->
        <div
          v-if="loggedIn"
          :class="$style.signUpBtn"
        >
          <b-button
            squared
            size="sm"
            :class="$style.customButton"
            @click="logout"
          >
            <font-awesome-icon
              :icon="['fal', 'ban']"
              :class="$style.addIcon"
            />
            Log Out
          </b-button>
        </div>
        <!-- Log in button -->
        <ul :class="$style.loginBtn">
          <NavBarRoutes
            v-if="loggedIn"
            :routes="loggedInNavRoutes"
          />
          <NavBarRoutes
            v-else
            :routes="loggedOutNavRoutes"
          />
        </ul>
        <!-- Cart button -->
        <div :class="$style.cartBtn">
          <router-link :to="{ name: 'cart', props: { site: siteSlug } }">
            <div
              class="text-left"
              :class="$style.cartIconWrapper"
            >
              <BaseIcon
                name="shopping-cart"
                library="fal"
              />
              <span :class="$style.cartBadge">
                {{ cartSize }}
              </span>
            </div>
          </router-link>
        </div>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import NavBarRoutes from '@components/nav-bar/nav-bar-routes'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    NavBarRoutes,
  },

  data() {
    return {
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Login',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      cartSize: 'shoppingCart/getCartLength',
      items: 'shoppingCart/getShoppingCartItems',
      siteSlug: 'sites/getSiteSlug',
      loggedIn: 'auth/loggedIn',
      currentUser: 'auth/getUser',
    }),
    loggedInNavRoutes() {
      const routes = []
      if (this.loggedIn) {
        routes.push({
          name: 'profile',
          title: () =>
            `${this.currentUser.firstName}'${
              this.currentUser.firstName.slice(-1) === 's' ? '' : 's'
            } account`,
        })
      }
      return routes
    },
    accountPage() {
      return this.$route.name === 'profile'
    },
  },

  methods: {
    ...mapActions({
      triggerLogout: 'auth/logOut',
    }),
    logout: function () {
      if (this.accountPage) {
        this.$router.push({
          name: 'PublicSiteHome',
          params: { site: this.siteSlug },
        })
      }
      this.triggerLogout()
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.addIcon {
  margin: 0 4px 0 0;
  font-size: 14px;
}
.navOptionsWrapper {
  top: 10px;
  li {
    display: inline-block;
    margin-top: 0.6rem;
    margin-right: $size-grid-padding;
    list-style-type: none;
  }
  .cartIconWrapper {
    height: 100%;
    margin-top: 0.45rem;
    font-size: 28px;
  }
}

.signUpBtn,
.loginBtn,
.cartBtn {
  padding: 0 20px;
}

.loginBtn,
.cartBtn {
  padding: 0 1.25rem 0 0;
  a {
    color: #333;
  }
}

.link {
  display: inline-block;
}

.customButton {
  position: relative;
  // top: -5px;
  display: inline-block;
  padding: 8px 12px;
  color: var(--brandColor);
  background-color: #fff;
  border: 1px solid var(--brandColor);
}

.customButton:hover,
.customButton:focus {
  color: #fff;
  background-color: var(--brandColor);
  border-color: var(--brandColor);
}

.cartBadge {
  position: relative;
  top: -17px;
  left: -6px;
  display: inline-block;
  min-width: 24px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: bold;
  color: var(--brandColor);
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid var(--brandColor);
  border-radius: 20px;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 1);
}
</style>
